import { Outlet } from "react-router-dom";
import { isEmpty } from "lodash";
// utilities
import useServerCustomHeader from "@/hooks/useServerCustomHeader";
// types
import useClientLanguage from "@/hooks/useClientLanguage";
import useClientSiteSettings from "@/hooks/useClientSiteSettings";
import useOptions from "@/hooks/useOptions";


const Render = (props:any) => {

    const optionsFetched = useOptions({ language:props.languageCode });

    if ( optionsFetched ) {
        return <Outlet />;
    }

    return null;
}

const WebApplicationStarter = () => {
    const headerFetched = useServerCustomHeader([{ key:"tenant", storageKey: "TENANT"}]);
    const languagesFetched = useClientLanguage();
    const siteSettingsFetched = useClientSiteSettings();

    if ( headerFetched && !isEmpty(languagesFetched) && siteSettingsFetched ) {
        return <Render languageCode={languagesFetched.code} />
    }

    return null;
}

export default WebApplicationStarter;
